import React from 'react';
import { Campaign } from "@dev/ee-api/ee-api-models";
import {
    CustomTableRowsProps,
    DotsIcon,
    palette,
    SimplePopover,
    SimplePopoverPlainOption,
    TableRowNameLink,
    TemplatePreview,
    Typography,
} from '@dev/ee-components';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PreviewCampaign } from "@/store/campaigns/actions";
import { CampaignsInterface } from '@/store/campaigns/types';
import { isCampaignsReportAvailable } from '@/components/Campaigns';
import { getApiPath } from '@/services/Secuirty';
import { StatusBadgeComponent } from '@/components/Campaigns/CampaignsList/components/StatusBadge';
import { goToCampaign } from '@/components/Campaigns/CampaignsList/helpers';
import { getConfigStore } from '@/store';
import { getDropdownTableOptions } from '../functions/getDropdownTableOptions';
import { useDropdownAction } from './useDropdownAction';

export const useTableRows = (campaigns: CampaignsInterface): CustomTableRowsProps[] => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const config = useSelector(getConfigStore);
    const { getDropdownAction } = useDropdownAction();
    return campaigns?.collection?.map((singleCampaign: Campaign, index: number): CustomTableRowsProps => {
        const isReportAvailable = isCampaignsReportAvailable(singleCampaign);
        const campaignTemplatesThumbnail = singleCampaign?.CampaignTemplates[0]?.MediumScreenshot
            ? `${getApiPath()}/userfile${singleCampaign.CampaignTemplates[0].MediumScreenshot}`
            : '';

        return {
            preview: (
                <div onClick={(ev): void => { ev.stopPropagation() }} >
                    <TemplatePreview
                        split={singleCampaign.CampaignTemplates.length > 1}
                        screenshot={campaignTemplatesThumbnail}
                        onClick={(): void => {
                            dispatch(PreviewCampaign(singleCampaign));
                        }}
                    />
                </div>
            ),
            campaignName:
                <div style={{ paddingLeft: '5px' }}>
                    <Typography variant="caption" color={palette.gray[7]} className="campaign-name">
                        <TableRowNameLink
                            onClick={(ev): void => {
                                ev.stopPropagation();
                                goToCampaign(dispatch, config, singleCampaign, isReportAvailable);
                            }}
                        >
                            {singleCampaign.Name}
                        </TableRowNameLink>
                    </Typography>
                </div>,
            opened: singleCampaign?.TrackingOptions?.TrackOpens ? (singleCampaign?.Stats?.Opened) : (<Typography variant="body1" align="right">{t('na')}</Typography>),
            clicked: singleCampaign?.TrackingOptions?.TrackClicks ? (singleCampaign.Stats.Clicked) : (<Typography variant="body1" align="right">{t('na')}</Typography>),
            status: [
                <StatusBadgeComponent status={singleCampaign.Status} index={index} key={index} />,
                <StatusBadgeComponent status={singleCampaign.Status} index={index} key={index} />,
            ],
            dropdown: (
                <div onClick={(ev): void => { ev.stopPropagation() }} style={{ cursor: 'pointer' }} >
                    <SimplePopover type="icon"
                        options={getDropdownTableOptions(singleCampaign)}
                        onItemClick={(e, option) => { getDropdownAction(e, option as SimplePopoverPlainOption, singleCampaign)}}>
                        <DotsIcon />
                    </SimplePopover>
                </div>
            ),
            rowID: singleCampaign.Name,
        };
    });
};
